const PoField = (props) => {
	const ipgw_po_message_field = (e) => {
		if( '' != e.target.value ) {
			document.getElementById('ipgw_po_message_field').classList.add('is-active');
			window.setExtensionData('ipgw-invoice-payment-method-pofield','ipgw_payment_po_field', e.target.value);

		} else {
			document.getElementById('ipgw_po_message_field').classList.remove('is-active');
		}
	}
	if ( props.is_enabled === true ) {
		return (
			<>
				<div className="wc-block-components-text-input" id="ipgw_po_message_field">
					<label>PO Number(optional)</label>
					<input 
						type="text" 
						id="ipgw_rule_po_field" 
						name="name_ipgw_rule_po_field" 
						onChange={ipgw_po_message_field} 
					/>
				</div>
				<p>We will generate and send you an invoice for your order, if you have a PO number, please enter it.</p>
			</>
		)
	}
}

export default PoField
